
export enum MyTimeCategory {
    MEETING         = 4,
    ACTIVE_TASK     = 3,
    PLANNED_TASK    = 2,
    VIEWED_TASK     = 1
}

export enum MyTimeView {
    DAILY           = 'daily',
    WEEKLY          = 'weekly'
}
